var ENV_DEVELOPMENT = 'development';
var ENV_PRODUCTION = 'production';
var ENV_FILE_LOCAL = '.env';
var ENV_FILE_TEST = '.env.test';
var ENV_FILE_DEVELOPMENT = '.env.development';
var ENV_FILE_STAGING = '.env.staging';
var ENV_FILE_PRODUCTION = '.env.production';
var ENV_FILES = [ENV_FILE_LOCAL, ENV_FILE_TEST, ENV_FILE_DEVELOPMENT, ENV_FILE_STAGING, ENV_FILE_PRODUCTION];
var COUNTRY_BE = 'BE';
var COUNTRY_BG = 'BG';
var COUNTRY_DK = 'DK';
var COUNTRY_DE = 'DE';
var COUNTRY_FI = 'FI';
var COUNTRY_FR = 'FR';
var COUNTRY_GR = 'GR';
var COUNTRY_HU = 'HU';
var COUNTRY_IE = 'IE';
var COUNTRY_IT = 'IT';
var COUNTRY_HR = 'HR';
var COUNTRY_LI = 'LI';
var COUNTRY_LT = 'LT';
var COUNTRY_LU = 'LU';
var COUNTRY_MC = 'MC';
var COUNTRY_NL = 'NL';
var COUNTRY_NO = 'NO';
var COUNTRY_AT = 'AT';
var COUNTRY_PL = 'PL';
var COUNTRY_PT = 'PT';
var COUNTRY_RO = 'RO';
var COUNTRY_SM = 'SM';
var COUNTRY_SK = 'SK';
var COUNTRY_SI = 'SI';
var COUNTRY_ES = 'ES';
var COUNTRY_CZ = 'CZ';
var COUNTRY_GB = 'GB';
var COUNTRY_SE = 'SE';
var COUNTRY_CH = 'CH';
var AVAILABLE_COUNTRIES = [COUNTRY_BE, COUNTRY_BG, COUNTRY_DK, COUNTRY_DE, COUNTRY_FI, COUNTRY_FR, COUNTRY_GR, COUNTRY_HU, COUNTRY_IE, COUNTRY_IT, COUNTRY_HR, COUNTRY_LI, COUNTRY_LT, COUNTRY_LU, COUNTRY_MC, COUNTRY_NL, COUNTRY_NO, COUNTRY_AT, COUNTRY_PL, COUNTRY_PT, COUNTRY_RO, COUNTRY_SM, COUNTRY_SK, COUNTRY_SI, COUNTRY_ES, COUNTRY_CZ, COUNTRY_GB, COUNTRY_SE, COUNTRY_CH];
var LANGUAGE_NL = 'nl';
var LANGUAGE_EN = 'en';
var LANGUAGE_FR = 'fr';
var LANGUAGE_DE = 'de';
var AVAILABLE_LANGUAGES = [LANGUAGE_NL, LANGUAGE_EN, LANGUAGE_FR, LANGUAGE_DE];
var REQUEST_PASSWORD_TYPE_RESET = 'RESET';
var REQUEST_PASSWORD_TYPE_INVITE = 'INVITE';
var USER_TYPE_ADMIN = 'ADMIN';
var USER_TYPE_CUSTOMER = 'CUSTOMER';
var ADMIN_USER_STATUS_CREATED = 'CREATED';
var ADMIN_USER_STATUS_INVITED = 'INVITED';
var ADMIN_USER_STATUS_ACTIVE = 'ACTIVE';
var DEFAULT_PAGE_SIZE = 25;
var DEFAULT_DATE_FORMAT = 'dd/mm/yyyy';
var DEFAULT_TIMEZONE = 'Europe/Brussels';
var DEFAULT_LANGUAGE = LANGUAGE_NL;
var DEFAULT_COUNTRY = COUNTRY_BE;
var ORDER_BY_ASC = 'ASC';
var ORDER_BY_DESC = 'DESC';
var PERMISSION_READ_PRODUCTS = 'READ_PRODUCTS';
var PERMISSION_WRITE_PRODUCTS = 'WRITE_PRODUCTS';
var PERMISSION_READ_ORDERS = 'READ_ORDERS';
var PERMISSION_WRITE_ORDERS = 'WRITE_ORDERS';
var PERMISSION_READ_USERS = 'READ_USERS';
var PERMISSION_WRITE_USERS = 'WRITE_USERS';
var PERMISSION_WRITE_ROLES = 'WRITE_ROLES';
var PERMISSION_READ_CUSTOMERS = 'READ_CUSTOMERS';
var PERMISSION_READ_SETTINGS = 'READ_SETTINGS';
var PERMISSION_WRITE_SETTINGS = 'WRITE_SETTINGS';
var PERMISSION_UPLOAD_FILES = 'UPLOAD_FILES';
var PERMISSIONS = [PERMISSION_READ_PRODUCTS, PERMISSION_WRITE_PRODUCTS, PERMISSION_READ_ORDERS, PERMISSION_WRITE_ORDERS, PERMISSION_READ_USERS, PERMISSION_WRITE_USERS, PERMISSION_WRITE_ROLES, PERMISSION_READ_CUSTOMERS, PERMISSION_READ_SETTINGS, PERMISSION_WRITE_SETTINGS, PERMISSION_UPLOAD_FILES];
var ERROR_CODE_FORBIDDEN = 'FORBIDDEN';
var ERROR_CODE_BAD_USER_INPUT = 'BAD_USER_INPUT';
var ERROR_CODE_UNAUTHENTICATED = 'UNAUTHENTICATED';
var SUBSCRIPTION_EVENT_PRODUCT_CREATED = 'PRODUCTS_CREATED';
var MONGO_COLLECTION_PRODUCTS = 'products';
var MONGO_COLLECTION_ORDERS = 'orders';
var MONGO_COLLECTION_CARTS = 'carts';
var MONGO_COLLECTION_STORES = 'stores';
var MONGO_COLLECTION_USERS = 'users';
var MONGO_COLLECTION_ROLES = 'roles';
var MONGO_COLLECTION_GUESTS = 'guests';
var MONGO_COLLECTION_REFRESH_TOKENS = 'refreshToken';
var MONGO_COLLECTION_FILES = 'files';
var MONGO_COLLECTION_VARIATIONS = 'variations';
var MONGO_COLLECTION_CATEGORIES = 'categories';
var MONGO_COLLECTION_VARIATION_OPTIONS = 'variationOptions';
var MONGO_COLLECTION_VALUES = 'values';
var MONGO_COLLECTION_COUPONS = 'coupons';
var WEIGHT_UNIT_KG = 'kg';
var CURRENCY_UNIT_EUR = 'EUR';
var CURRENCY_UNIT_USD = 'USD';
var VISUAL_STYLE_HIDDEN = 'HIDDEN';
var VISUAL_STYLE_SELECT = 'SELECT';
var VISUAL_STYLE_COLOR_SWATCH = 'COLOR_SWATCH';
var VISUAL_STYLES = [VISUAL_STYLE_HIDDEN, VISUAL_STYLE_SELECT, VISUAL_STYLE_COLOR_SWATCH];
var CURRENCY_UNITS = [CURRENCY_UNIT_EUR, CURRENCY_UNIT_USD];
var WEIGHT_UNITS = [WEIGHT_UNIT_KG];
var PAYMENT_STATUS_UNKNOWN = 'UNKNOWN';
var PAYMENT_STATUS_CREATED = 'CREATED';
var PAYMENT_STATUS_PAID = 'PAID';
var PAYMENT_STATUS_AUTHORIZED = 'AUTHORIZED';
var PAYMENT_STATUS_SHIPPED = 'SHIPPED';
var PAYMENT_STATUS_PENDING = 'PENDING';
var PAYMENT_STATUS_FAILED = 'FAILED';
var PAYMENT_STATUS_EXPIRED = 'EXPIRED';
var PAYMENT_STATUS_CANCELED = 'CANCELED';
var PAYMENT_FAIL_STATUSES = [PAYMENT_STATUS_FAILED, PAYMENT_STATUS_EXPIRED, PAYMENT_STATUS_CANCELED];
var ORDER_STATUS_UNKNOWN = 'UNKNOWN';
var ORDER_STATUS_CREATED = 'CREATED';
var ORDER_STATUS_PAID = 'PAID';
var ORDER_STATUS_SHIPPED = 'SHIPPED';
var ORDER_STATUS_CANCELED = 'CANCELED';
var CART_STATUS_ACTIVE = 'ACTIVE';
var CART_STATUS_CONVERTED = 'CONVERTED';
var CART_STATUS_ABANDONED = 'ABANDONED';
var MAIL_TEMPLATE_ADMIN_INVITE = 'admin-invitation';
var MAIL_TEMPLATE_ADMIN_RESET_PASSWORD = 'admin-password-reset';
var MAIL_TEMPLATE_CUSTOMER_RESET_PASSWORD = 'customer-password-reset';
var MAIL_TEMPLATE_CUSTOMER_CONTACT = 'customer-contact';
var MAIL_TEMPLATE_CUSTOMER_ORDER_CONFIRM = 'customer-order-confirm';
var MAIL_TEMPLATE_ADMIN_ORDER_CONFIRM = 'admin-order-confirm';
var PATH_GRAPHQL_ADMIN = '/graphql/admin';
var PATH_GRAPHQL_CUSTOMER = '/graphql/customer';
var PATH_PAYMENT_WEBHOOK = '/payment/completed';
var PATH_PAYMENT_REDIRECT = '/afrekenen/:orderId/afronden';
var FILE_TYPE_PRODUCT_IMAGE = 'PRODUCT_IMAGE';
var FILE_TYPES = [FILE_TYPE_PRODUCT_IMAGE];
var PHONE_FORMAT = '+32 4## ## ## ##';
var COUPON_TYPE_SINGLE_USE = 'SINGLE_USE';
var COUPON_TYPES = [COUPON_TYPE_SINGLE_USE];

export { ADMIN_USER_STATUS_ACTIVE, ADMIN_USER_STATUS_CREATED, ADMIN_USER_STATUS_INVITED, AVAILABLE_COUNTRIES, AVAILABLE_LANGUAGES, CART_STATUS_ABANDONED, CART_STATUS_ACTIVE, CART_STATUS_CONVERTED, COUNTRY_AT, COUNTRY_BE, COUNTRY_BG, COUNTRY_CH, COUNTRY_CZ, COUNTRY_DE, COUNTRY_DK, COUNTRY_ES, COUNTRY_FI, COUNTRY_FR, COUNTRY_GB, COUNTRY_GR, COUNTRY_HR, COUNTRY_HU, COUNTRY_IE, COUNTRY_IT, COUNTRY_LI, COUNTRY_LT, COUNTRY_LU, COUNTRY_MC, COUNTRY_NL, COUNTRY_NO, COUNTRY_PL, COUNTRY_PT, COUNTRY_RO, COUNTRY_SE, COUNTRY_SI, COUNTRY_SK, COUNTRY_SM, COUPON_TYPES, COUPON_TYPE_SINGLE_USE, CURRENCY_UNITS, CURRENCY_UNIT_EUR, CURRENCY_UNIT_USD, DEFAULT_COUNTRY, DEFAULT_DATE_FORMAT, DEFAULT_LANGUAGE, DEFAULT_PAGE_SIZE, DEFAULT_TIMEZONE, ENV_DEVELOPMENT, ENV_FILES, ENV_FILE_DEVELOPMENT, ENV_FILE_LOCAL, ENV_FILE_PRODUCTION, ENV_FILE_STAGING, ENV_FILE_TEST, ENV_PRODUCTION, ERROR_CODE_BAD_USER_INPUT, ERROR_CODE_FORBIDDEN, ERROR_CODE_UNAUTHENTICATED, FILE_TYPES, FILE_TYPE_PRODUCT_IMAGE, LANGUAGE_DE, LANGUAGE_EN, LANGUAGE_FR, LANGUAGE_NL, MAIL_TEMPLATE_ADMIN_INVITE, MAIL_TEMPLATE_ADMIN_ORDER_CONFIRM, MAIL_TEMPLATE_ADMIN_RESET_PASSWORD, MAIL_TEMPLATE_CUSTOMER_CONTACT, MAIL_TEMPLATE_CUSTOMER_ORDER_CONFIRM, MAIL_TEMPLATE_CUSTOMER_RESET_PASSWORD, MONGO_COLLECTION_CARTS, MONGO_COLLECTION_CATEGORIES, MONGO_COLLECTION_COUPONS, MONGO_COLLECTION_FILES, MONGO_COLLECTION_GUESTS, MONGO_COLLECTION_ORDERS, MONGO_COLLECTION_PRODUCTS, MONGO_COLLECTION_REFRESH_TOKENS, MONGO_COLLECTION_ROLES, MONGO_COLLECTION_STORES, MONGO_COLLECTION_USERS, MONGO_COLLECTION_VALUES, MONGO_COLLECTION_VARIATIONS, MONGO_COLLECTION_VARIATION_OPTIONS, ORDER_BY_ASC, ORDER_BY_DESC, ORDER_STATUS_CANCELED, ORDER_STATUS_CREATED, ORDER_STATUS_PAID, ORDER_STATUS_SHIPPED, ORDER_STATUS_UNKNOWN, PATH_GRAPHQL_ADMIN, PATH_GRAPHQL_CUSTOMER, PATH_PAYMENT_REDIRECT, PATH_PAYMENT_WEBHOOK, PAYMENT_FAIL_STATUSES, PAYMENT_STATUS_AUTHORIZED, PAYMENT_STATUS_CANCELED, PAYMENT_STATUS_CREATED, PAYMENT_STATUS_EXPIRED, PAYMENT_STATUS_FAILED, PAYMENT_STATUS_PAID, PAYMENT_STATUS_PENDING, PAYMENT_STATUS_SHIPPED, PAYMENT_STATUS_UNKNOWN, PERMISSIONS, PERMISSION_READ_CUSTOMERS, PERMISSION_READ_ORDERS, PERMISSION_READ_PRODUCTS, PERMISSION_READ_SETTINGS, PERMISSION_READ_USERS, PERMISSION_UPLOAD_FILES, PERMISSION_WRITE_ORDERS, PERMISSION_WRITE_PRODUCTS, PERMISSION_WRITE_ROLES, PERMISSION_WRITE_SETTINGS, PERMISSION_WRITE_USERS, PHONE_FORMAT, REQUEST_PASSWORD_TYPE_INVITE, REQUEST_PASSWORD_TYPE_RESET, SUBSCRIPTION_EVENT_PRODUCT_CREATED, USER_TYPE_ADMIN, USER_TYPE_CUSTOMER, VISUAL_STYLES, VISUAL_STYLE_COLOR_SWATCH, VISUAL_STYLE_HIDDEN, VISUAL_STYLE_SELECT, WEIGHT_UNITS, WEIGHT_UNIT_KG };
